/* eslint-disable react-hooks/exhaustive-deps */
import { WarningIcon } from '@chakra-ui/icons';
import {
	Box,
	FormControl,
	FormHelperText,
	FormLabel,
	ListItem,
	NumberDecrementStepper,
	NumberIncrementStepper,
	NumberInput,
	NumberInputField,
	NumberInputStepper,
	Popover,
	PopoverArrow,
	PopoverBody,
	PopoverContent,
	PopoverTrigger,
	Text,
	UnorderedList,
	useDisclosure,
} from '@chakra-ui/react';
import { Field, useFormikContext } from 'formik';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import constants from '../../constant';
import { getWorkingDays } from '../../utils/leave-utils';

const InputNumberFormField = ({ name = null, label = null, min = 1, max = 100, step = 1, precision = 2, disabled = false, required = false }) => {
	const { t } = useTranslation();
	const { values } = useFormikContext();
	const { isOpen, onOpen, onClose } = useDisclosure();
	const [holidays, setHolidays] = useState([]);

	useEffect(() => {
		const { leaveFromDate, leaveToDate } = values;
		if (leaveFromDate && leaveToDate) {
			const { excludedHolidays } = getWorkingDays(leaveFromDate, leaveToDate);
			setHolidays(excludedHolidays);
		}
	}, [values]);

	const Info = () => {
		return (
			<>
				{holidays?.length > 0 && (
					<Popover size="sm" returnFocusOnClose={true} isOpen={isOpen} onClose={onClose} placement="right" closeOnBlur={true}>
						<PopoverTrigger>
							<WarningIcon boxSize={3} onClick={onOpen} />
						</PopoverTrigger>
						<PopoverContent _focus={{ boxShadow: 'none', outline: 'none' }}>
							<PopoverArrow />
							<PopoverBody>
								<Text fontSize="sm" fontWeight="600" color="gray.600">
									{t('Public Holidays')}
								</Text>
								<UnorderedList spacing={1}>
									{holidays?.map((holiday) => (
										<ListItem>
											<Text fontSize="sm" fontWeight="500" color="gray.600">
												{moment(holiday).locale('km').format(constants.dateTextOnlyFormat)}
											</Text>
										</ListItem>
									))}
								</UnorderedList>
							</PopoverBody>
						</PopoverContent>
					</Popover>
				)}
			</>
		);
	};

	return (
		<Field name={name}>
			{({ field, meta, form }) => {
				return (
					<Box mb="4">
						<FormControl id={name}>
							<FormLabel>
								{t(label)}
								{required && <span style={{ color: 'red' }}>*</span>}
							</FormLabel>
							<NumberInput
								isDisabled={disabled}
								defaultValue={parseFloat(field?.value)}
								min={min}
								max={max}
								step={step}
								precision={precision}
								onChange={(value) => form.setFieldValue(name, parseFloat(value))}
							>
								<NumberInputField />
								<NumberInputStepper>
									<NumberIncrementStepper />
									<NumberDecrementStepper />
								</NumberInputStepper>
							</NumberInput>
							{meta.touched && meta.error && (
								<FormHelperText id={`error-message-${name}`} color="red.400" fontSize="12px">
									{t(name)}&nbsp;{t('is')}&nbsp;{t(meta.error)}&nbsp;
									<Info />
								</FormHelperText>
							)}
						</FormControl>
					</Box>
				);
			}}
		</Field>
	);
};

export default InputNumberFormField;
